import {
  type EdgeId,
  type SnapshotId,
  isTopologyEdgeData,
} from '@ipfabric/utils';
import type { DeviceExplorerEdgeData } from 'components/DeviceView/deviceViewTypes';
import { getDeviceExplorerEdgeData } from 'components/DeviceView/helpers/getDeviceExplorerEdgeData';
import type { GraphData } from 'components/Graph/model/GraphData';

export const getUpdatedEdgeData = (
  edgeIds: EdgeId[],
  graphData: GraphData,
  snapshotToCompareId: SnapshotId | null,
): Map<EdgeId, DeviceExplorerEdgeData> => {
  return edgeIds.reduce(
    (
      acc: Map<EdgeId, DeviceExplorerEdgeData>,
      edgeId: EdgeId,
    ): Map<EdgeId, DeviceExplorerEdgeData> => {
      const { edges, nodes } = graphData;
      const edgeData = edges[edgeId];
      if (edgeData !== undefined && isTopologyEdgeData(edgeData)) {
        const sourceSn = nodes[edgeData.source]?.sn ?? null;
        const targetSn = nodes[edgeData.target]?.sn ?? null;
        return acc.set(
          edgeId,
          getDeviceExplorerEdgeData(
            edgeData,
            graphData,
            sourceSn,
            targetSn,
            snapshotToCompareId,
          ),
        );
      }
      return acc;
    },
    new Map(),
  );
};
